import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, LinearProgress } from "@mui/material";
import stylesCss from "../../Approval/style";
import { Button } from "@mui/material";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import { t } from "i18next";
import { Tittle } from "../style";

const StepTwo = ({ setActiveStep }) => {
  let navigate = useNavigate();
  const [wait, setWait] = useState(false);
  const classesSx = stylesCss;
  const { rucVendor, vendor, getPrimaryContact, setStartEnrollment } =
    useContext(ContactContext);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleBecomeSupplier = async () => {
    await Promise.all([setStartEnrollment(true)]);
    let path = `/Vendor/Enrollment`;
    navigate(path);
  };
  const onSubmit = async () => {
    setWait(true);
    if (rucVendor !== "") {
      await Promise.all([getPrimaryContact(rucVendor)]);
      handleNext();
    }
    setWait(false);
  };

  return (
    <>
      {wait && <LinearProgress color="error" />}

      <br />
      <Tittle>{t("companyInformation")}</Tittle>
      <br />
      <br />
      {vendor[0].length !== 0 ? (
        vendor.map((searchVendor) => (
          <div key={searchVendor.custVendAC}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <label htmlFor="inputEmail4">{t("name")}</label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputEmail4"
                      placeholder={t("name")}
                      value={searchVendor.dirPartyName}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <label htmlFor="inputPassword4">
                      {t("identification")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="inputEmail4"
                      placeholder={t("identification")}
                      value={searchVendor.custVendAC}
                      disabled
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        ))
      ) : (
        <div>
          <h3>{t("companyNotFound")}</h3>
          <br />
        </div>
      )}
      <br />
      <br />
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={5}>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnRegresar,
              }}
            >
              <Button
                sx={{ ...classesSx.btnBuscarRegresar }}
                variant="contained"
                onClick={handleBack}
              >
                {t("back")}
              </Button>
            </Grid>
            <Grid
              item
              xs={6}
              md={6}
              lg={6}
              sx={{
                ...classesSx.gridBtnContinuar,
              }}
            >
              {!(vendor[0].length !== 0) ? (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  variant="contained"
                  onClick={handleBecomeSupplier}
                >
                  {t("becomeSupplier")}
                </Button>
              ) : (
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  variant="contained"
                  onClick={onSubmit}
                >
                  {t("next")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default StepTwo;
